<template>
<div class="third_party">
<div>
  <div class="money">
    <div class="header">
      <div class="header-left">
        <div class="bold" @click="buyOrSell(1)">
<!--          购买-->
          <div>{{$t('300417')}}</div>
          <span :class="{active:active == 1}" ></span>
        </div>
        <span></span>
        <div class="bold" @click="buyOrSell(2)">
<!--          出售-->
          <div>{{$t('300367')}}</div>
          <span :class="{active:active == 2}" ></span>
        </div>
      </div>
      <div class="header-right pointer" @click="openFAQ">
        <i class="iconfont icon-FAQ"></i>
        <span class="bold">FAQ</span>
      </div>
    </div>
    <div class="main">
      <div class="currency">
<!--        货币-->
        <p class="bold">{{ $t('300366') }}</p>


       <div :class="zenT()">
         <div class="currency-left" :class="demon1()">
<!--           支付-->
          <span>{{ $t('200368') }}</span>
           <div :class="{focus:isfocus}">
             <input v-if="active == 1" @input="fiatInput" @blur.stop="isfocus = false" type="text" @focus.stop="isfocus = true" :placeholder="`${channel.minAmount!=undefined ? channel.minAmount :''}`" :maxlength="12"  v-model="amount"/>
             <input :class="input1()" v-if="active == 2" @input="currencyInput" @blur.stop="isfocus = false" :placeholder="`${channel.minAmount!=undefined ? channel.minAmount :''}`" type="text" @focus.stop="isfocus = true" v-model="amount"/>
             <!-- 300192 全部 -->
             <div class="getMax" v-if="(token || $route.query.token) && active == 2" @click="getMax()">{{$t('300192')}}</div>
             <div @click.stop="isShowPopup(active == 1 ? 'fiat' : 'currency')">
               <van-image :show-loading="false"	 v-if="active == 2" :src="currency.img">
                 <template v-slot:error>
                   <img  src="../../assets/images/currency.png"/>
                 </template>
               </van-image>
               <van-image :show-loading="false" v-if="active == 1" :src="fiat.img">
                 <template v-slot:error>
                   <img  src="../../assets/images/fiat.png"/>
                 </template>
               </van-image>
               <span v-if="active == 2">{{currency.currency!=undefined ? (currency.currency+'').toUpperCase() : ''}}</span>
               <span v-if="active == 1">{{fiat.fiat != undefined ? fiat.fiat : ''}}</span>
               <i class="iconfont icon-a-Frame4"></i>
             </div>
           </div>
           <p class="errorMessage">{{ errorMessage }}</p>
         </div>
         <div class="currency-right" :class="fixStyle1()">
<!--           收到-->
           <span>{{active == 1 ? $t('300369') : $t('300370')}}</span>
           <div :class="fixStyle2()" @click.stop="isShowPopup(active == 2 ? 'fiat' : 'currency')">
             <van-image :show-loading="false"	 v-if="active == 1" :src="currency.img">
               <template v-slot:error>
                 <img  src="../../assets/images/currency.png"/>
               </template>
             </van-image>
             <van-image :show-loading="false" v-if="active == 2" :src="fiat.img">
               <template v-slot:error>
                 <img  src="../../assets/images/fiat.png"/>
               </template>
             </van-image>
             <span v-if="active == 1">{{currency.currency!=undefined ? (currency.currency+'').toUpperCase() : ''}}</span>
             <span v-if="active == 2">{{fiat.fiat != undefined ? fiat.fiat : ''}}</span>
             <i :class="fixStyle3()" class="iconfont icon-a-Frame4"></i>
           </div>
         </div>
       </div>

        <p v-if="active === 2" class="userAllAssets">
<!--          可用余额-->
          <span>{{ $t('300402') }}:&nbsp;</span>
          <span >{{assetsAmount != '' ? assetsAmount.substring(0, assetsAmount.indexOf('.') + 9) : '--'}} {{currency.currency!=undefined ? (currency.currency+'').toUpperCase(): '' }}</span>
          <span v-if="token || $route.query.token" class="tranText" @click="goTransfer">
            <!-- 划转 -->
            {{$t('9100076')}}
            <svg slot="image" class="icon huazhuanIcon" aria-hidden="true">
              <use xlink:href="#icon-huazhuan-copy" />
            </svg>
          </span>
        </p>
      </div>
      <div class="payMethods">
<!--        付款方式-->
        <p class="bold">{{ active == 1 ? $t('300372') : $t('300373') }}</p>
        <div class="payList">
          <div v-if="payList.length" @click.stop="isShowPopup('pay')">
           <div>
             <van-image :show-loading="false" :src="payMethods.img">
               <template v-slot:error>
                 <img  src="../../assets/images/pay.png"/>
               </template>
             </van-image>
             <span>{{ payMethods.name }}</span>
           </div>
            <i class="iconfont icon-a-Frame4"></i>
          </div>
          <div class="payNoData" v-if="!payList.length">
<!--            暂无数据-->
            {{$t('300108')}}
          </div>
        </div>
      </div>
      <div class="channel">
<!--        支付渠道-->
        <p class="bold">{{ $t('300374') }}</p>
        <div class="channelList" v-my-circle="loading">
          <div @click="chooseData(item,'channel')" :class="{channelActive:item.id == channel.id}" class="channelItem" v-for="(item,index) in channelList"  :key="index">
            <div >
              <van-image :show-loading="false" :src="item.img">
                <template v-slot:error>
                  <img  src="../../assets/images/channel.png"/>
                </template>
              </van-image>
              <span>{{item.name}}</span>
            </div>
            <div>
              <span>{{ item.amount || '--' }}</span>&nbsp;
              <span>{{active == 2 ? (fiat.fiat+'').toUpperCase():(currency.currency+'').toUpperCase()}}</span>
            </div>
            <svg v-show="channel.id == item.id" class="ltr">
              <use :xlink:href="isDirection ? '#icon-gouxuan-fan' : '#icon-gouxuan'"></use>
            </svg>
          </div>
          <div v-if="!channelList.length" class="channelNoData">
            {{$t('300108')}}
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="orderMessage">
<!--          订单详细信息-->
          <span class="bold">{{ $t('300375') }}</span>
          <p class="amount">
<!--            金额(含交易费用)-->
            <span>{{$t('300376')}}</span>
            <span class="bold">{{isPassRules ? allfee||'0.00' : '0.00'}} {{active == 1 ? (fiat.fiat+'').toUpperCase():(currency.currency+'').toUpperCase()}}</span>
          </p>
          <p>
<!--            到达时间-->
            <span>{{ $t('300377') }}</span>
            <span class="bold">{{$t('300414',{time:'5~60'})}}</span>
          </p>
        </div>
        <div class="disclaimer">
<!--          免责声明-->
          <span class="bold">{{ $t('300378') }}</span>
          <p v-html="$t('300380',{name:channel.name!=undefined ? channel.name : '',server: channel.protocolLink!=undefined ? channel.protocolLink:'',Customer: channel.customerLink!=undefined ? channel.customerLink:''})"></p>
        </div>
      </div>

    </div>
    <div class="howBuyOrSell">
      <p class="bold">
<!--        如何在SuperEx上购买加密货币-->
        {{ active == 1 ? $t('300381') : $t('300382') }}
      </p>
      <div class="step">
        <div class="stepItem">
          <div>
            <svg>
              <use xlink:href="#icon-a-xiadan1"></use>
            </svg>
          </div>
          <div class="stepItem-right">
            <div class="title">
<!--              下达加密货币订单-->
              {{$t('300383') }}
            </div>
            <div class="describe">
<!--              选择您想要支付的法定货币和您想要购买的加密货币。输入您想要花费的金额。-->
              {{$t('300384')}}
            </div>
          </div>
        </div>
        <div class="stepItem">
          <div>
            <svg>
              <use xlink:href="#icon-a-KYC1"></use>
            </svg>
          </div>
          <div class="stepItem-right">
            <div class="title">
<!--              验证您的身份-->
              {{$t('300385')}}
            </div>
            <div class="describe">
              {{$t('300386')}}
<!--              在SuperEx和支付提供商上完成KYC验证，完成支付。-->
            </div>
          </div>
        </div>
        <div class="stepItem">
          <div>
            <svg>
              <use xlink:href="#icon-dingdan2"></use>
            </svg>
          </div>
          <div class="stepItem-right">
            <div class="title">
              {{$t('300387')}}
<!--              检查您的订单详细信息-->
            </div>
            <div class="describe">
              {{$t('300388')}}
<!--              检查您的存款历史记录以查看订单状态。-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="questions">
<!--      常见问题-->
      <p class="bold">{{ $t('300389') }}</p>
      <div class="questionItem">
        <van-collapse v-model="activeNames">
          <van-collapse-item name="1">
            <template #title>
<!--              1. 我可以使用哪些支付方式购买加密货币？-->
              <div><span class="bold">{{ $t('300390') }}</span> <van-icon :name="activeNames.includes('1') ? 'minus' : 'plus'" /></div>
            </template>
<!--            SuperEx目前支持VISA、Mastercard、Apple Pay、Google Pay等多种支付方式。支持的第三方服务提供商包括 Mercuryo、alchemypay。-->
          <div>{{
              $t('300391')
            }}</div>
          </van-collapse-item>
          <van-collapse-item name="2">
              <template #title>
<!--                2. 我可以购买哪些加密货币？-->
                <div><span class="bold">{{ $t('300392') }}</span> <van-icon :name="activeNames.includes('2') ? 'minus' : 'plus'" /></div>
              </template>
<!--            SuperEx supports mainstream cryptocurrencies such as BTC, ETH, USDT, LTC, EOS, XRP, BCH, ETC, and TRX.-->
              <div> {{ $t('300393')}}</div>
          </van-collapse-item>
          <van-collapse-item name="3">
              <template #title>
<!--                3. SuperEx是否监控支持的第三方服务提供商的质量和价格？-->
                <div><span class="bold">{{$t('300394')}}</span> <van-icon :name="activeNames.includes('3') ? 'minus' : 'plus'" /></div>
              </template>
<!--            SuperEx精心挑选了一批具有值得信赖的行业信誉、知名度、安全性的服务提供商，为用户提供流程化的服务。-->
              <div>{{ $t('300395') }}</div>
          </van-collapse-item>
          <van-collapse-item name="4">
            <template #title>
<!--              4. 购买加密货币需要支付哪些费用？-->
              <div><span class="bold">{{ $t('300396') }}</span> <van-icon :name="activeNames.includes('4') ? 'minus' : 'plus'" /></div>
            </template>
<!--            您向第三方服务提供商支付费用和链上转账费用。SuperEx不收取任何费用。-->
            <div>{{ $t('300397') }}</div>
          </van-collapse-item>
          <van-collapse-item name="5">
            <template #title>
<!--              5. 付款后需要多长时间才能收到加密货币？-->
              <div><span class="bold">{{ $t('300398') }}</span> <van-icon :name="activeNames.includes('5') ? 'minus' : 'plus'" /></div>
            </template>
<!--            当您在第三方服务商平台完成支付后，您的加密货币将在大约2-10分钟内存入您的SuperEx现货账户。-->
            <div>{{ $t('300399') }}</div>
          </van-collapse-item>
          <van-collapse-item name="6">
            <template #title>
<!--              6、购买过程中遇到问题怎么办？-->
              <div><span class="bold">{{ $t('300400') }}</span> <van-icon :name="activeNames.includes('6') ? 'minus' : 'plus'" /></div>
            </template>
<!--            如果您在交易过程中遇到任何问题，请联系客户支持。如果您付款完成后仍未收到加密货币，请联系第三方服务提供商检查 订单详细信息（这通常是最有效的方法）。由于您当前所在地区的IP或某些政策原因，您必须选择人工验证。-->
            <div>{{ $t('300401') }}</div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
  <div class="consentAgreement">
<!--    我已阅读并同意免责声明-->
    <p><van-checkbox v-model="checked" checked-color="#FFC72B"></van-checkbox><span>{{ $t('300379') }}</span></p>
    <van-button class="bold" @click="submit" :disabled="!isDiable">{{ $t('300056') }}</van-button>
  </div>
  <van-popup position="bottom" :close-on-click-overlay="false"	 :style="{ height: '60%' }" v-model="show" :lock-scroll="true">
    <div class="popup-container">
      <div class="popup-header">
      <span class="bold">{{title}}</span>
      <span @click="closePopup">
      <i class="iconfont icon-guanbi1"></i>
    </span>
    </div>
     <div v-if="PopupStatus!=='pay'" class="search">
       <van-search
         v-model="value"
         left-icon="icon-sousuo"
         shape="round"
         background="transparent"
         :placeholder="PopupStatus == 'currency'?$t('300404'):$t('300405')"
         :clearable="false"
       >
         <template slot="left-icon">
           <i class="iconfont icon-sousuo"></i>
         </template>
       </van-search>
     </div>
      <p class="popup-name" v-if="PopupStatus!=='pay'">{{ name || '--' }}</p>
      <div class="popup-main-container">
        <div @click="chooseData(item)" v-for="(item,index) in filterData" :key="index">
          <div v-if="PopupStatus == 'pay' && item.name != 'Apple Pay' && isAndroid||PopupStatus!='pay'||!isAndroid" :class="[PopupStatus !== 'pay' ?  'noChannel':'isChannel',item.id === commonObj.id ? 'active' : '']" >
            <van-image :show-loading="false" :src="item.img">
              <template v-slot:error>
                <img v-if="PopupStatus === 'currency'"  src="../../assets/images/currency.png" alt=""/>
                <img v-if="PopupStatus === 'fiat'"  src="../../assets/images/fiat.png" alt=""/>
                <img v-if="PopupStatus === 'pay'"  src="../../assets/images/pay.png" alt=""/>
              </template>
            </van-image>
            <span v-if="PopupStatus == 'pay'">{{ item.name }}</span>
            <span v-if="PopupStatus == 'currency'"> {{ item.currency.toUpperCase() }}</span>
            <span v-if="PopupStatus == 'fiat'"> {{ item.fiat.toUpperCase() }}</span>
          </div>
        </div>

        <div v-if="!filterData.length" class="PopupNoData">
          <van-empty class="custom-image" :description="$t('300108')">
            <svg slot="image" class="icon" aria-hidden="true">
              <use :xlink:href="$route.query.theme === 'sunlight' ? '#icon-jilu1':'#icon-zanwujilu'"></use>
            </svg>
          </van-empty>
        </div>
      </div>
    </div>
  </van-popup>
  <van-dialog v-model="dialogVisible" :showConfirmButton="false">
    <div class="real-name-verification" v-if="user.type!=3 && $route.query.token">
      <p class="title bold">{{ $t('300406') }} </p>
<!--      为了您与您交易用户的账号安全，请先完成身份认证-->
      <p class="describe">{{ $t('300407') }}</p>
<!--      去认证-->
      <van-button class="confirm" @click="goVerification">{{ $t('300408') }}</van-button>
<!--      暂不认证-->
      <van-button class="cancel" @click="dialogVisible = false">{{ $t('300409') }}</van-button>
    </div>
    <div class="notSupport" v-if="user.type == 3  && $route.query.token">
      <p>{{$t('300415')}}</p>
      <van-button class="cancel" @click="goBackApp">{{ $t('300286') }}</van-button>
    </div>
  </van-dialog>
</div>
</div>
</template>

<script>
import {Button, Checkbox, Popup, Search, Image, Toast,Empty,Collapse,CollapseItem,Icon,Dialog} from "vant";
import { getCurrency,getFiat,thirdParty_channelList,thirdParty_payList,placeAnOrder,getUserAmount } from "../../api/resource";
import {mapGetters} from "vuex";
import {setCookie, setToken} from "../../utils/auth";
import { getUserInfo } from "../../api/user";
import { getToken, removeToken, removeCookie, getCookie } from '@/utils/auth'
export default {
  name: "index",
  components:{
    VanButton:Button,
    VanCheckbox:Checkbox,
    VanPopup:Popup,
    VanSearch:Search,
    VanImage:Image,
    VanEmpty:Empty,
    VanCollapse:Collapse,
    VanCollapseItem:CollapseItem,
    VanIcon:Icon,
    VanDialog:Dialog.Component
  },
  data(){
    return {
      checked:false,
      show: false,
      popupStatus:'currency',
      dialogVisible:false,
      amount:'',
      active:1,
      currency: {},
      fiat: {},
      payMethods:{},
      isfocus:false,
      assetsAmount: '',
      value:'',
      channel: {},
      currencyList:[],
      fiatList: [],
      payList: [],
      loading: false,
      loading1: false,
      channelList: [],
      PopupStatus: '',
      commonList: [],
      commonObj:{},
      activeNames: [],
      allfee: '',
      errorMessage: '',
      isPassRules:false,
      timer:null,
      isTrue:false,
      request: false,
      title:'',
      name:'',
      language:'',
      isAndroid:'',
      curFiat:{},
    }
  },
   created() {
    console.log(this.$route.query,'this.$route.query-this.$route.query');
    this.isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
    if(this.$route.query.token){
      getUserInfo(this.$route.query.token).then(res => {
        if(res.data.type == 3){
          this.dialogVisible = true
        }
      })
    }else{
      removeToken()
      removeCookie('userData')
    }
    // console.log(window.location.href)
    this.resHer()
    this.getData()
  },
  computed:{
    ...mapGetters(['isDirection','token','user']),
    isDiable(){
      return this.checked && this.amount!=='' && this.payList.length && this.channelList.length && this.isPassRules
    },
    filterData(){
      let list = [], ishave = []
      if(this.value == '' || this.PopupStatus === 'pay' || this.PopupStatus === 'channel'){
        list = this.commonList
        return list
      }else{
        this.commonList.forEach(item => {
          if(item[this.PopupStatus].toUpperCase() === this.value.toUpperCase()){
            list.unshift(item)
            return;
          }
          if(item[this.PopupStatus].substring(0,this.value.length).toUpperCase() === this.value.toUpperCase()){
            list.push(item)
            return;
          }
          if(item[this.PopupStatus].toUpperCase().includes(this.value.toUpperCase())){
            ishave.push(item)
          }
        })
        list = list.concat(ishave)
      }
      return list || []
    },
  },
  methods:{
    goTransfer(){
      if (this.$route.query.isApp == 1) {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.goTransfer,
                        { code: 200 },
                        (data) => { }
                    )
                } else {
                    this.$router.push('/downLoad')
                }
    },
    getMax(){
      // console.log(this.assetsAmount,'assetsAmount');
      this.amount = this.assetsAmount
    },
    zenT(){
      if(this.active == '2'){
        return 'newSellStyle'
      }
    },
    demon1(){
      if(this.active == '2'){
        return 'newSellStyle1'
      }
    },
    fixStyle1(){
      if(this.active == '2'){
        return 'topGet'
      }
    },
    fixStyle2(){
      if(this.active == '2'){
        return 'fixStyle2'
      }
    },
    fixStyle3(){
      if(this.active == '2'){
        return 'fixStyle3'
      }
    },
    input1(){
      if(this.active == '2'){
        return 'topInputStyle'
      }
    },
    input2(){

    },
    openFAQ(){
      window.location.href = this.$t('300416')
    },
    goVerification(){
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appVerification,
        {},
        (data) => {}
      )
    },
    goBackApp(){
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.goBack,
        {},
        (data) => {}
      )
    },
    getUserAssets(){
      console.log(this.user)
      getUserAmount({userId:this.user.id,currency: this.currency.currency}).then(res => {
        this.assetsAmount = res.data.available
      })
    },
    resHer(){
      // window.document.documentElement.setAttribute(
      //   'dir',
      //   this.$route.query.language == 'fa' ? 'rtl' : 'ltr'
      // )

      let token = this.$route.query.token || this.token
      this.$i18n.locale = this.$route.query.language
      window.document.documentElement.setAttribute(
        'data-theme',
        this.$route.query.theme || 'moon'
      )
      this.$store.dispatch('setLanguage', this.$route.query.language)
      this.$store.dispatch(
        "setIsDirection",
        this.$route.query.language == "fa" ? true : false
      );
      setCookie(
        "language",
        this.$route.query.language ? this.$route.query.language : "en"
      );
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
      if(this.$route.query.token){
        setToken(this.$route.query.token);
        this.$store.dispatch('GetInfo',this.$route.query.token)
      }
    },
    submit(){
      window.gtag('event', 'third party_select', {'third party_button':this.active == 1 ? 'buy' : 'sell'})
      if(!this.isTrue)return
      if(this.token || this.$route.query.token){
        if(this.request)return
        this.request = true
        placeAnOrder({
          type: this.channel.type,
          tradeType: this.active,
          amount: this.amount,
          fiat: this.fiat.fiat,
          currency: this.currency.currency,
          paymentId: this.payMethods.id,
          clientType:2
        }).then(res => {
          if(res.code == 200){
            if(this.channel.type == 2 && this.payMethods.id == 17 || this.payMethods.id == 3){
              this.$jsBridge.callHandler(
                this.$jsBridgeCmd.goBrowser,
                { code: 200, link: res.data.urlWithParam ? res.data.urlWithParam : "" },
                data => {}
              );
            }else{
              window.location.href = res.data.urlWithParam
            }
            this.request = false
          }
          else if(res.code == 502){
            this.dialogVisible = true
            // console.log(window.location.href)
            this.request = false
          }else if(res.code == 500){
            Toast(res.msg)
          }
          setTimeout(()=>{
            this.request = false
          },1000)
        }).catch(e => {

          setTimeout(()=>{
            this.request = false
          },1000)
        })
      }else{
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appLogin,
          { code: 200, type: "login" },
          data => {}
        );
      }

    },
    replaceStr() {
      const value = this.amount //法币输入限制只能输入正数且最多两位小数
      if (
        value.length == 2 &&
        value[0] === '0' &&
        value.indexOf('.') === -1
      ) {
        this.amount = value.substr(1)
      }
      this.amount = this.amount.replace(
        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
        '$1'
      )
      this.allfee = this.isPassRules ? this.amount : ''
    },
    replaceStr1() {
      const value = this.amount //法币输入限制只能输入正数且最多8位小数
      if (
        value.length == 2 &&
        value[0] === '0' &&
        value.indexOf('.') === -1
      ) {
        this.amount = value.substr(1)
      }
      this.amount = this.amount.replace(
        /^\D*([0-9]\d*\.?\d{0,8})?.*$/,
        '$1'
      )
      this.allfee = this.isPassRules ? this.amount : ''
    },
    fiatInput(){
      this.isTrue = false
      this.replaceStr()
      // if(this.payList.length > 0  && this.channelList.length > 0){
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getChannel()
        },500)
      // }
    },
    currencyInput(){
      if(!this.$route.query.token){
        this.appLogin()
        return
      }
      this.isTrue = false
      this.replaceStr1()
      // if(this.payList.length > 0  && this.channelList.length > 0){
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getChannel()
        },500)
      // }
    },
    fiatRules(){
      if((this.channel.minAmount * 1 > this.amount * 1 || this.channel.maxAmount * 1 < this.amount * 1) && this.amount){
        this.isPassRules = false
        this.allfee = ''
        // 单笔限额:
       this.errorMessage = `${this.$t('300371')}${this.channel.minAmount + '-' + this.channel.maxAmount }${this.fiat.fiat.toUpperCase()}`
      }else{
        this.isPassRules = true
        this.isTrue = true
        this.allfee = this.amount
        this.errorMessage = ''
      }
    },
    currencyRules(){
      if((this.channel.minAmount * 1 > this.amount * 1 || this.channel.maxAmount * 1 < this.amount * 1) && this.amount){
        this.isPassRules = false
        this.allfee = ''
        // 单笔限额:
        this.errorMessage = `${this.$t('300371')}${this.channel.minAmount + '-' + this.channel.maxAmount }${this.currency.currency.toUpperCase()}`
      }else if(this.amount && this.amount * 1 > this.assetsAmount * 1){
        this.errorMessage = this.$t('300403')
        this.isPassRules = false
        this.allfee = ''
      }else{
        this.isPassRules = true
        this.isTrue = true
        this.allfee = this.amount
        this.errorMessage = ''
      }
    },
    buyOrSell(val){
      console.log(val,'val--val');
      if(this.active == val)return
      this.active = val
      this.amount = ''
      this.channel = {}
      this.errorMessage = ''
      this.getData()
    },
    closePopup(){
      this.show = false
      this.value = ''
    },
    chooseData(val,type){
    console.log(val,'--val');
      if(type === 'channel'){
        this.channel = val
        this.errorMessage = ''
        this.active == 1 ? this.fiatRules() : this.currencyRules()
        return
      }
      this.show = false
      this.value = ''
      switch (type){
        case 'currency':
          this.currency = val
          this.getPay()
          if(this.active == 2){
            this.getUserAssets()
          }
          break
        case 'fiat':
          this.fiat = val
          this.getPay()
          break
      }

      switch (this.PopupStatus){
        case 'currency':
          this.currency = val
          this.getPay()
          if(this.active == 2){
            this.getUserAssets()
          }
          break
        case 'fiat':
          this.fiat = val
          this.getPay()
          break
        case 'pay':
          this.payMethods = val
          this.getChannel()
          break
      }

    },
    isShowPopup(type){
      this.PopupStatus = type
      this.show = true
      let setMap = {
        'currency': this.$t('300410'),
          'fiat': this.$t('300411'),
          'pay': this.$t('300372'),
      }
      let setName = {
        'currency':this.$t('300412'),
          'fiat':this.$t('300413'),
      }
      this.title = setMap[this.PopupStatus]
      this.name = setName[this.PopupStatus]
      switch (type){
        case 'currency':
          this.commonList = JSON.parse(JSON.stringify(this.currencyList))
          this.commonObj = this.currency
          console.log(this.commonObj,'this.commonObj-this.commonObj');
          break
        case 'fiat':
          this.commonList = JSON.parse(JSON.stringify(this.fiatList))
          this.commonObj = this.fiat
          break
        case 'pay':
          this.commonObj = this.payMethods
          this.commonList = JSON.parse(JSON.stringify(this.payList))
          break
      }
    },
    getData(){
      Promise.all([getCurrency({tradeType: this.active}),getFiat({tradeType: this.active})]).then(res=>{
         const [currency,fiat]= res
         this.fiatList = fiat.data.length > 0 ? fiat.data : []
         this.currencyList = currency.data.length > 0 ? currency.data : []
         this.currency = currency.data.length > 0 ? currency.data[0] : {}
         this.fiat = fiat.data.length > 0 ? fiat.data[0] : {}
         this.getPay()
        if(this.$route.query.token && this.user.id!=undefined){
          this.getUserAssets()
        }
        let queryCurrency = this.$route.query.currency ? this.$route.query.currency.toLowerCase() : ''
                    let queryAmount = this.$route.query.amount
                    let queryRate = this.$route.query.rate
                    if(this.$route.query.currency && this.$route.query.rate){
                        const noramlCurrencyData = {currency:"btc",id:6,img:"https://sandbox-api.mrcr.io/v1.6/img/icons/currencies/btc.png"}
                        const noramlFiatData = {fiat:"USD",id:7,img:"https://sandbox-api.mrcr.io/v1.6/img/icons/currencies/usd.png"}
                        const curData = this.currencyList.find(i=> i.currency === queryCurrency ) || noramlCurrencyData
                        const curFiat = this.fiatList.find(i=> i.fiat === queryRate ) || noramlFiatData
                        console.log(curData,'curData--curData--curData');
                        console.log(curFiat,'curFiat-curFiat-curFiat');

                        if(this.currencyList.find(i=> i.currency === queryCurrency )){
                          this.chooseData(curData,'currency')
                          if(curFiat){
                              this.chooseData(curFiat,'fiat')
                          }
                          this.amount = queryAmount
                        }else{
                          this.chooseData(noramlCurrencyData,'currency')
                          this.chooseData(noramlFiatData,'fiat')
                        }

                    }
        })
    },
    appLogin(){
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appLogin,
        {
          code: 200,
          type: "login",
        },
        data => {
        }
      );
    },
    getPay(){
      this.loading1 = true
      thirdParty_payList({
        currency: this.currency.currency,
        fiat: this.fiat.fiat,
        tradeType: this.active
      }).then(res => {
        this.payList = res.data.length > 0 ? res.data : []
        this.payMethods = res.data.length > 0 ? res.data[0] : {}
        this.payList.length > 0 ? this.getChannel():this.channelList = []
        if(!res.data.length){
          this.errorMessage = ''
          this.isPassRules = false
        }
      }).catch(e => {
      })
    },
    getChannel(){
      this.loading = true
      thirdParty_channelList({
        currency: this.currency.currency ,
        fiat: this.fiat.fiat,
        paymentId: this.payMethods.id,
        tradeType: this.active,
        amount: this.amount
      }).then(res => {
        this.channelList = res.data.length > 0 ? res.data : []
        this.channel =  res.data[0] || {}
        setTimeout(()=>{
          this.loading = false
        },500)
        if(!res.data.length){
          this.errorMessage = ''
          this.isPassRules = false
        }
        if(this.amount!=='' && res.data.length > 0){
          this.active == 1 ? this.fiatRules() : this.currencyRules()
        }
      }).catch(e => {
        setTimeout(()=>{
          this.loading = false
        },500)
      })
    }
  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir = 'ltr'] .third_party{
  /deep/ input{
    direction:ltr!important;
    text-align: left;

  }
 .main{
   border-radius: 0 torem(16) torem(16);
 }
  /deep/ .van-cell__title {
    .van-icon {
      margin-left: torem(12);
    }
  }
  .header{
    border-radius: torem(16) 0 0;
    &-left{
      clip-path: polygon(0% 0%, 90% 0%, 100% 100%, 0% 100%);
      border-radius: torem(10) torem(50) 0 0;
    }
  }
  .channelList{
    svg{
      right: torem(-1);
    }
  }
}
[dir = 'rtl'] .third_party{
  /deep/ input{
    direction:rtl!important;
    text-align: right;
  }
  .main{
    border-radius:torem(16) 0 torem(16) torem(16) ;
  }
  /deep/ .van-cell__title {
    .van-icon {
      margin-right: torem(12);
    }
  }
  .header{
    border-radius: torem(16) 0 0;
    &-left{
      border-radius: torem(50) torem(10) 0 0;
      clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%);
    }
  }
  .channelList{
    svg{
      left: torem(-1);
    }
  }
}

[dir = 'ltr']{
  .getMax{
    right: 5rem;
  }
  .tranText{
    margin-left: torem(8);

  }
  .fixStyle3{
    right: 0.4rem;
}
}
[dir = 'rtl']{
  .getMax{
    left: 5rem;
  }
  .tranText{
    margin-right: torem(8);

  }
  .fixStyle3{
    left: 0.4rem;
}
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../assets/css/mixin";
@import "../../style/mixin";
.third_party{
  height: 100vh;
  width: 100%!important;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  padding: torem(12) torem(16) torem(200);
  >div{
    width: 100%;
    //@include background_color('input-bg-color');
    min-height: 100vh;
    .money{
      width: 100%;
      .header{
        width: 100%;
        height: torem(48);
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        &-left{
          height: 100%;
          width: torem(225);
          font-size: torem(14);
          display: flex;
          justify-content: flex-start;
          padding: torem(16) torem(16) torem(8);
          @include font_color('font-color');
          @include background_color('background-color-2');
          >div{
            position: relative;
            //text-align: center;
            display: flex;
            justify-content: center;
            //align-items: center;
            >span{
              position: absolute;
              display: inline-block;
              bottom: 0;
              width: torem(32);
              height: torem(2);
              left: 50%;
              transform: translateX(-50%);
              background: transparent;
              &.active{
                background:rgba(217, 163, 26, 1) ;
              }
            }
          }
          >span{
            display: inline-block;
            @include background_color('line-color');
            width: torem(1);
            height: torem(16);
            margin: 0 torem(16);
          }
        }
        &-right{
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: torem(56);
          background: transparent;
          padding: 0 torem(4);
          i{
            font-size: torem(16);
            color: rgba(217, 163, 26, 1);
          }
          span{
            font-size: torem(14);
            color: rgba(217, 163, 26, 1);
          }
        }
      }
      .main{
        padding: torem(20) torem(16);
        width: 100%;
        @include background_color('background-color-2');
        .currency{
          .userAllAssets{
            word-break: break-all;
            @include font_color('font-color-1');
            display: flex;
            align-items: center;
            font-size: torem(12);
            margin-top: torem(8);
          }
          position: relative;
          width: 100%;
          min-height: torem(106);
          //@include background_color('input-bg-color');
          margin-bottom: torem(32);
          .errorMessage{
            position: absolute;
            bottom: torem(-16);
            color: #F65D62 !important;
            font-size: torem(12);
          }
          >p{
            font-size: torem(14);
            line-height: torem(16);
            @include font_color('font-color');
          }
          >div{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: torem(16);
          }
          &-left{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            height:torem(73) ;
            width: torem(203);
            >span{
              @include font_color('font-color-1');
              font-size: torem(14);
              line-height: torem(16);
            }
            .focus {
              //>div{
                border-color: rgba(217, 163, 26, 1)!important;
                transition: all 0.5s;
              //}
            }
            >div{
              margin-top: torem(8);
              padding: 0 torem(8);
              height: torem(48);
              width: 100%;
              display: flex;
              align-items: center;
              border: torem(1) solid;
              border-radius: torem(4);
              @include border_color('border-color-normal');
              @include background_color('input-bg-color');
             >div{
               display: flex;
               align-items: center;
               /deep/ .van-image{
                 width: torem(20);
                 height: torem(20);
                 .van-image__error{
                   background: transparent;
                 }
               }
               img{
                 width: torem(20);
                 height: torem(20);
                 border-radius: 50%;
                 object-fit: cover;
               }
               span{
                 font-size: torem(14);
                 @include font-color('font-color');
                 display: inline-block;
                 margin: 0 torem(4);
               }
               i{
                 @include font-color('font-color-2');
                 font-size: torem(12);
                 transform: scale(0.75);
               }
             }


              input{
                height: 100%;
                overflow: hidden;
                background: transparent;
                //text-indent: torem(8);
                width: torem(132);
                @include font_color('font-color');
                &::placeholder{
                  @include font_color('font-color-1');
                }
                font-size: torem(14);
              }
            }
          }
          &-right{
            min-width: torem(100);
            height:torem(73);
            >span{
              @include font_color('font-color-1');
              font-size: torem(14);
              line-height: torem(16);
            }
            /deep/ .van-image{
              width: torem(20);
              height: torem(20);
              .van-image__error{
                background: transparent;
              }
            }
            >div{
              height: torem(48);
              margin-top: torem(8);
              @include background_color('input-bg-color');
              border: torem(1) solid;
              border-radius: torem(4);
              @include border_color('border-color-normal');
              padding: 0 torem(14);
              display: flex;
              align-items: center;
              img{
                width: torem(20);
                height: torem(20);
                border-radius: 50%;
                object-fit: cover;
              }
              span{
                font-size: torem(14);
                @include font-color('font-color');
                display: inline-block;
                margin: 0 torem(4);
              }
              i{
                @include font-color('font-color-2');
                font-size: torem(12);
                transform: scale(0.75);
              }
            }
          }
        }
        .payMethods,.channel{
          width: 100%;
          min-height: torem(78);
          //@include background_color('input-bg-color');
          margin-bottom: torem(32);


          .payList{
            .payNoData{
              display: flex;
              justify-content: center;
              align-items: center;
              @include font-color('font-color-1');
              font-size: torem(12);
            }
            >div{
              width: torem(311);
              height: torem(48);
              padding: 0 torem(8);
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: torem(14);
              @include font-color('font-color');
              border: torem(1) solid;
              @include border_color('border-color-normal');
              @include background_color('input-bg-color');
              border-radius: torem(4);
              /deep/ .van-image{
                .van-image__error{
                  background: transparent;
                }
                width: torem(36);
                height: torem(24);
              }
              >div{
                display: flex;
                align-items: center;
              }
              img{
                width: torem(36);
                height: torem(24);
                object-fit: cover;
              }
              span{
                display: inline-block;
                margin: 0 torem(4);
                font-size: torem(14);
                @include font_color('font-color');
              }
              i{
                font-size: torem(12);
                transform: scale(0.75);
              }
            }
          }
          .channelList{
            .channelNoData{
              display: flex;
              justify-content: center;
              align-items: center;
              height: torem(48);
              width: torem(311);
              @include font-color('font-color-1');
              border: torem(1) solid;
              @include border_color('border-color-normal');
              @include background_color('input-bg-color');
              border-radius: torem(4);
              font-size: torem(12);
            }
            /deep/ .channelActive{
              border-color: #FFC72B!important;
            }
            .channelItem{
              display: flex;
              justify-content: space-between;
              position: relative;
              align-items: center;
              height: torem(48);
              width: torem(311);
              @include font-color('font-color');
              border: torem(1) solid;
              @include border_color('border-color-normal');
              @include background_color('input-bg-color');
              border-radius: torem(4);
              padding: 0 torem(8);
              margin-bottom: torem(8);
              svg{
                position: absolute;
                bottom: torem(0)!important;
                width: torem(20);
                height: torem(20);
              }
              >div{
                span{
                  font-size: torem(14)!important;
                  @include font_color('font-color');
                  flex-shrink: 0;
                }
                &:first-child{
                  display: flex;
                  align-items: center;
                  >span{
                    margin: 0 torem(8);
                    display: inline-block;
                  }
                }
                &:last-child{
                  display: flex;
                  align-items: center;
                }
              }

             /deep/ .van-image,img{
               .van-image__error{
                 background: transparent;
               }
                width: torem(20);
                height: torem(20);
                object-fit: cover;
                border-radius: 50%;
              }
            }
          }
          >p{
            font-size: torem(14);
            @include font-color('font-color');
            margin-bottom: torem(16);
          }
        }
      }
      .footer{
        .orderMessage{
          >span{
            display: block;
            font-size: torem(14);
            @include font_color('font-color');
          }
          .amount{
            //display: inline-block;
            margin-top: torem(18);
            margin-bottom: torem(8);
          }
          p{
            font-size: torem(14);
            line-height: torem(21);
            display: flex;
            justify-content: space-between;
            align-items: center;
            span{
              @include font_color('font-color-1');
              &:first-child{
                font-size: torem(14);
              }
              &:last-child{
                display: inline-block;
                font-size: torem(16);
                @include font_color('font-color');
                //margin: 0 torem(16);
              }
            }
          }
        }
        .disclaimer{
          margin-top: torem(32);
          span{
            @include font_color('font-color-2');
            font-size: torem(14);
            line-height: torem(21);
          }

          p{
            font-size: torem(14);
            line-height: torem(21);
            @include font-color('font-color-1');
            /deep/ a{
              color:rgba(217, 163, 26, 1)!important;
            }
          }
        }

      }
      .howBuyOrSell{
        >p{
          margin: torem(20) 0;
          font-size: torem(14);
          @include font-color('font-color');
          line-height: torem(21);
        }
        .step{
          padding: 0 torem(16);
          border-radius: torem(16);
          @include background_color('background-color-2');
          .stepItem{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: torem(20) 0;
            svg{
              width: torem(48);
              height: torem(48);
            }
            &-right{
              padding: 0 torem(16);
              .title{
                font-size: torem(14);
                @include font_color('font-color');
              }
              .describe{
                margin-top: torem(8);
                font-size: torem(14);
                @include font-color('describe-color');
                line-height: torem(16);
              }
            }
          }
        }
      }
      .questions{
        border-radius: torem(16);
        @include background_color('background-color-2');
        padding:torem(20) torem(16) 0 ;
        /deep/ .van-cell__title{
          .van-icon{
            margin-top: torem(4);
          }
         >div{
           display: flex;
           justify-content: space-between;
         }
          font-size: torem(14);
          @include font_color('font-color');
          line-height: torem(21);
        }
        margin-top: torem(20);
        >p{
          font-size: torem(14);
          @include font-color('font-color');
        }
        /deep/ .van-collapse-item__content{
          padding: 0!important;
          font-size: torem(14);
          @include font-color('describe-color');
          line-height: torem(21);
          margin-top: torem(14);
        }
        /deep/ .van-cell__right-icon{
          display: none;
        }
        /deep/ .van-cell{
          padding: 0;

        }
        /deep/ .van-cell::after{
          display: none;

        }
        /deep/ .van-collapse-item{
          padding: torem(24) 0 ;
          &:after{
            display: none;

          }
        }
        /deep/ .van-collapse-item div{
          background: transparent!important;
          border: none!important;
        }
        /deep/ .van-collapse:after{
          display: none;
        }
        ///deep/ .van-cell__title{
        //  padding: torem(24) 0;
        //}
      }
    }
    .consentAgreement{
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 99;
      @include background_color('background-color');
      width: 100vw;
      padding: torem(24) torem(28);
      p{
        @include font-color('font-color');
        display: flex;
        //align-items: center;
        line-height: torem(16);
        justify-content: flex-start;
        font-size: torem(14);
        /deep/ .van-checkbox{
          width: torem(16);
          height: torem(16);
          .van-checkbox__icon{
            font-size: torem(16);
          }
        }
        >span{
          display: inline-block;
          margin:0 torem(8);
          line-height: torem(16);
          flex: 1;
        }
      }
      /deep/ .van-button{
        border: none;
        width:torem(319);
        border-radius: torem(4);
        height: torem(44);
        margin-top: torem(12);
        font-size: torem(16);
        color: rgba(0, 0, 0, 0.90);
        background: #FFC72B;
      }
      /deep/ .van-button--disabled{
       @include background_color('disable-btn');
        @include font_color('disale-color');
        color: rgba(255,255,255,.25);
      }
    }
  }
  @include background_color('background-color');
  /deep/ .van-popup{
    @include background_color('dialog-background');
    border-radius:torem(16) torem(16) 0 0 ;
  }
}
/deep/ .van-checkbox__icon--checked .van-icon{
  color: rgba(0, 0, 0, 0.90);
}
.popup-container{
  height: 100%;
  display: flex;
  flex-direction: column;
  .active{
    @include background_color('input-bg-color');
  }
  .isChannel{
    height: torem(56);
    padding: torem(16);
    display: flex;
    align-items: center;
    /deep/ .van-image{
      width: torem(36);
      height: torem(24);
      .van-image__error{
        background: transparent;
      }
    }
    img{
      width: torem(36);
      height: torem(24);
      object-fit: cover;
    }
    span{
      font-size: torem(14);
      @include font_color('font-color');
      margin: 0 torem(8);
    }
  }
  .noChannel{
    height: torem(56);
    padding: torem(16);
    display: flex;
    align-items: center;
    /deep/ .van-image{
      width: torem(24);
      height: torem(24);
      .van-image__error{
        background: transparent;
      }
    }
    img{
      width: torem(24);
      height: torem(24);
      border-radius: 50%;
      object-fit: cover;
    }
    span{
      font-size: torem(14);
      @include font_color('font-color');
      margin: 0 torem(8);
    }
  }
  .popup-main-container::-webkit-scrollbar {
    display: none;
  }
  .popup-main-container{
    flex: 1;
    overflow-y: auto;
    padding-bottom: torem(10);
  }
  .popup-name{
    font-size: torem(12);
    @include font-color('font-color');
    margin-top: torem(12);
    margin-bottom: torem(12);
  }
  .search,.popup-name{
    padding:0 torem(16);
  }
  .popup-header{
    padding: torem(16) torem(16) 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //height: torem(24);
    margin: torem(8) 0;
    font-size: torem(16);
    line-height: torem(24);
    @include font_color('font-color');
    span{
      display: inline-block;
      i{
        font-size: torem(14);
        @include font-color('close-btn');
      }
    }
  }
  /deep/ .van-search{
    padding: 0!important;
  }
  /deep/ .van-search__content--round{
    border-radius:torem(18)!important;
    padding: 0 torem(16);
  }
  .van-search__content{
    height: torem(36);
    width: torem(343);
    @include background_color('input-bg-color');
    /deep/ .van-cell{
      padding: 0!important;
    }

    div{
      height: torem(36);
      line-height: torem(36);

      /deep/ i{
        font-size: torem(14)!important;
        @include font_color('font-color-2');
      }
      /deep/ .van-field__control{
        @include font-color('font-color');
        font-size: torem(14);
      }
      /deep/ input{
        &::placeholder{
          @include font-color('font-color-1');
          text-align: start;
          text-indent: torem(2);
        }
        height: torem(36);
      }
    }
  }

}
//.PopupNoData{
  /deep/ .custom-image {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    > p {
      text-align: center;
    }
  }
 .custom-image {
    padding-top: torem(60) !important;
   /deep/ .van-empty__image{
      width: torem(60);
      height: torem(80);
      svg {
        width: torem(60);
        height: torem(80);
      }
    }
  }
//}
/deep/ .van-empty__description {
  font-size: torem(14)!important;
}
.van-dialog{
  @include background_color('dialog-background');

}
.notSupport{
  padding: torem(24) torem(24) torem(12);
  display: flex;
  flex-direction: column;
  align-items: center;
  p{
    font-size: torem(14);
    font-size: torem(14);
    line-height: torem(21);
    text-align: center;
    @include font-color('font-color');
  }
  /deep/ .van-button{
    background: rgba(255, 199, 43, 1);
    width: torem(264);
    height: torem(44);
    font-size: torem(16);
    margin-top: torem(24);
    border-radius: torem(4);
  }
  .cancel{
    color: rgba(0, 0, 0, 0.90)!important;
  }
}
.real-name-verification{
  .title{
    font-size: torem(16);
    @include font-color('font-color');
    margin:torem(16) 0;
    text-align: center;
    line-height: torem(18);
  }
  .describe{
    margin-bottom: torem(24);
    font-size: torem(14);
    line-height: torem(21);
    text-align: center;
    @include font-color('font-color');
  }
}
/deep/ .van-dialog{
  width: torem(312);
  border-radius: torem(8)!important;
  .real-name-verification{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: torem(24) torem(24) torem(12);
    .confirm{
      border: none;
      background: rgba(255, 199, 43, 1);
      //@include font-color('font-color');
      color: rgba(0, 0, 0, 0.90);
    }

    .van-button{
      width: torem(264);
      height: torem(44);
      font-size: torem(16);
      border-radius: torem(4);
    }
  }
}
.cancel{
  border: none;
  @include font_color('font-color-1');
  background: transparent;
}
.newSellStyle{
  display: block !important;
}
.newSellStyle1{
  width: 100% !important;
}
.topInputStyle{
  width: 10.6rem !important;
}
.topGet{
  margin-top: torem(8);
}
.fixStyle2{
  justify-content: flex-start !important;
}
.fixStyle3{
    // justify-content: flex-end !important;
    position: absolute;
    // right: 0.4rem;
}
.getMax{
  position: absolute;
  font-family: Lato, Lato;
  font-weight: 400;
  font-size: torem(12);
  color: #D9A31A;
  // right: 5rem;
}
.huazhuanIcon{
  width: torem(9);
  height: torem(10);
}
.tranText{
  display: flex;
  align-items: center;
  font-family: Lato, Lato;
  font-weight: 400;
  font-size: torem(12);
  color: #D9A31A;
  // margin-left: torem(8);
  svg{
    // margin-left: torem(4);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/thirdParty/index.vue